import { useContext } from "react";
import { AuthContext } from "../components/auth/AuthProvider";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function ProtectedPayment() {
  const {
    user,
    googleUser,
    payed,
    payedStressFatigue,
    loading,
    precentCompletion,
  } = useContext(AuthContext);

  const location = useLocation();

  if (loading) {
    return null;
  }

  if (user === null && googleUser === null) {
    return <Navigate to="/login" replace />;
  }

  // if (
  //   (!payed &&
  //     payed === null &&
  //     location.pathname === "/success/love-and-disappointment") ||
  //   (!payedStressFatigue &&
  //     payedStressFatigue === null &&
  //     location.pathname === "/success/stress-and-fatigue")
  // ) {
  //   return <Navigate to="/" replace />;
  // }

  return <Outlet />;
}
